module.exports = __webpack_public_path__ + "img/banner.8321a41b.gif";